<script> 
import store from "@/state/store"; 
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimHarcamaLimit from "@/models/StrBirimHarcamaLimit";

export default {
  mixins: [Api, Sabit, StrBirimHarcamaLimit],
  page: {
    title: "%10 Tutarları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    formcombobox,
  },
  data() {
    return {
      title: this.$t("GetBirimButce.Title"),
      items: [
        {
          text: this.$t("GetBirimButce.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("GetBirimButce.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("GetBirimButce.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FilitrelemePenceresi: true,
      TableData: [],
      TableDataTutarlar: [],
      DonemCombobox: [],
      KullaniciBilgileri: null,
      Filter: {
        Donem: "",
      },
      ToplamMal22D: 0,
      ToplamMal21F: 0,
      ToplamMalDiger: 0,
      ToplamHizmet22D: 0,
      ToplamHizmet21F: 0,
      ToplamHizmetDiger: 0,
      ToplamYapim22D: 0,
      ToplamYapim21F: 0,
      ToplamYapimDiger: 0,
      ToplamToplam: 0,
      ToplamMal: 0,
      ToplamHizmet: 0,
      ToplamYapim: 0,   
    };
  },
  validations: {
    Filter: {
      Donem: {},
    },
  },
  methods: {
    Get() {
    },
    FilterGet() {
      if (this.Filter.Donem) {
        this.FilitrelemePenceresi = false;
      }
      let Filter = "&Donem=" + this.Filter.Donem;

      if(this.yetki_kontrol('SuperAdmin')<0  && this.yetki_kontrol('StrAdmin')<0) {

        Filter=Filter+"&YetkiliBirimGetir=true";
      }
      
      this.ActionsFilterGet({
        Service: "StrBirimKontrolTutarlari/GetBirimButce",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => { 
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;

        this.ToplamMal21F = 0;
        this.ToplamMal22D = 0;
        this.ToplamMalDiger = 0;
        this.ToplamHizmet21F = 0;
        this.ToplamHizmet22D = 0;
        this.ToplamHizmetDiger = 0;
        this.ToplamYapim21F = 0;
        this.ToplamYapim22D = 0;
        this.ToplamYapimDiger = 0;
        this.ToplamToplam = 0;
        this.ToplamMal = 0;
        this.ToplamHizmet = 0;
        this.ToplamYapim = 0;

        this.TableData.forEach((Data) => {
          this.ToplamMal21F += Data.tmal21f;
          this.ToplamMal22D += Data.tmal22d;
          this.ToplamMalDiger += (Data.tmal - Data.tmal22d - Data.tmal21f);
          this.ToplamHizmet21F += Data.thizmet21f;
          this.ToplamHizmet22D += Data.thizmet22d;
          this.ToplamHizmetDiger +=
            Data.thizmet - Data.thizmet22d - Data.thizmet21f;
          this.ToplamYapim21F += Data.tyapim21f;
          this.ToplamYapim22D += Data.tyapim22d;
          this.ToplamYapimDiger +=
            Data.tyapim - Data.tyapim22d - Data.tyapim21f;
          this.ToplamToplam += Data.tmal + Data.thizmet + Data.tyapim;
          this.ToplamMal += Data.tmal - Data.thmal22d - Data.thmal21f;
          this.ToplamHizmet +=
            Data.thizmet - Data.thhizmet22d - Data.thhizmet21f;
          this.ToplamYapim += Data.tyapim - Data.thyapim22d - Data.thyapim21f;
        });
      });
    }, 

    yetki_kontrol(yetki){

        var sonuc = this.KullaniciBilgileri.indexOf(yetki);
        return sonuc; 

    },


    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
  created() {
    this.KullaniciBilgileri = store.getters["auth/UserRolles"];

   /* let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({"Service":"StrPerfDonem", "Page":Page,"Filter":"&Approval=true"}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.DonemCombobox.push({
          Id: res.Data[i].YilBas,
          Value: res.Data[i].YilBas,
        });
      }
      const _ = require("lodash");
      this.DonemCombobox = _.keyBy(this.DonemCombobox, "Id");
    });  */


    this.DonemCombobox=[];
    for (var i=0 ; i<this.Yillar.length; i++){
      this.DonemCombobox.push ({Id:this.Yillar[i].id,Value:this.Yillar[i].value})
    }


  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end"> 

                         <b-dropdown variant="success" class="btn  btn-rounded mb-2 me-2">
                      <template v-slot:button-content>
                        <i class="mdi mdi-file-export-outline me-1"></i>
                        {{ $t("StrBirimButceHarcamalari.Page.Yazdir") }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item href="javascript: void(0);" @click="ExcelExport('Harcama Giriş', 'Harcama Giriş')">
                        {{ $t("StrBirimButceHarcamalari.Page.ExceleAktar") }}</b-dropdown-item>
                      <b-dropdown-item href="javascript: void(0);" @click="
                        Export2Word('exportContent', 'Harcama Giriş')
                      ">
                        {{ $t("StrBirimButceHarcamalari.Page.WordeAktar") }}</b-dropdown-item>
                    </b-dropdown>
 
                     
                    <button
                      type="button"
                      class="btn btn-secondary btn-rounded mb-2 me-2"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("GetBirimButce.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
            <div id="exportContent">
              <div class="table-responsive"  ref="ExcelExportTable">
                <table style="border-collapse: collapse; width:100% " class="table mb-0" ref="table" v-if="TableData.length">
                  <thead class="table-light">
                    <tr>
          <!--            <th style="border: 1px solid">
                        {{ $t("GetBirimButce.Table.str_ebutcekurumkodu") }}
                      </th> -->
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.birimadi") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.tmal") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.thizmet") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.tyapim") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.ToplamToplam") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.ToplamMal") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.ToplamHizmet") }}</th>
                      <th style="border: 1px solid">{{ $t("GetBirimButce.Table.ToplamYapim") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="TableDataVerileri in TableData"
                      :key="TableDataVerileri.Id"
                    >
                   <!--   <th style="border: 1px solid" scope="row">
                        {{ TableDataVerileri.str_ebutcekurumkodu }}
                      </th>  -->
                      <td style="border: 1px solid">{{ TableDataVerileri.birimadi }}</td>
                      <td style="border: 1px solid"> 
                            <div class="strTuru">{{
                                  
                                    TableDataVerileri.tmal | TrParaFormat
                                  
                                }}
                              </div> 
                      </td>
                      <td style="border: 1px solid"> 
                            <div class="strTuru">{{
                              
                                    TableDataVerileri.thizmet | TrParaFormat
                                
                                }}
                              </div> 
                      </td>
                      <td style="border: 1px solid"> 
                            <div class="strTuru">{{
                                 
                                    TableDataVerileri.tyapim | TrParaFormat
                                 
                                }}
                              </div> 
                      </td>
                      <td style="border: 1px solid">
                        {{
                          (
                            TableDataVerileri.tmal +
                            TableDataVerileri.thizmet +
                            TableDataVerileri.tyapim
                          ).toFixed(2)  | TrParaFormat
                        }}
                      </td>
                      <td style="border: 1px solid">
                        {{
                          (
                            TableDataVerileri.tmal -
                            TableDataVerileri.thmal22d -
                            TableDataVerileri.thmal21f
                          ).toFixed(2) | TrParaFormat
                        }}
                      </td>
                      <td style="border: 1px solid">
                        {{
                          (
                            TableDataVerileri.thizmet -
                            TableDataVerileri.thhizmet22d -
                            TableDataVerileri.thhizmet21f
                          ).toFixed(2) | TrParaFormat
                        }}
                      </td>
                      <td style="border: 1px solid">
                        {{
                          (
                            TableDataVerileri.tyapim -
                            TableDataVerileri.thyapim22d -
                            TableDataVerileri.thyapim21f
                          ).toFixed(2) | TrParaFormat
                        }}
                      </td>
                    </tr>
                    <tr v-if="TableData.length"> 
                      <td colspan="1" style="border: 1px solid">Genel Toplamlar</td>
                      <td style="border: 1px solid"> 
                            <div class="strTuru">{{ 
                              (parseFloat(ToplamMal22D)+
                              parseFloat(ToplamMal21F)+
                              parseFloat(ToplamMalDiger)
                              ).toFixed(2) | TrParaFormat }}
                              </div>   
                      </td>
                      <td style="border: 1px solid"> 
                            <div class="strTuru">
                              {{ 
                              (parseFloat(ToplamHizmet22D)+
                              parseFloat(ToplamHizmet21F)+
                              parseFloat(ToplamHizmetDiger)
                              ).toFixed(2) | TrParaFormat }}

                           </div>   
                      </td>
                      <td style="border: 1px solid"> 
                            <div class="strTuru">
                              {{ 
                              (parseFloat(ToplamYapim22D)+
                              parseFloat(ToplamYapim21F)+
                              parseFloat(ToplamYapimDiger)
                              ).toFixed(2) | TrParaFormat }}
                               </div>  
                      </td>
                      <td style="border: 1px solid">{{ ToplamToplam.toFixed(2) | TrParaFormat }}</td>
                      <td style="border: 1px solid">{{ ToplamMal.toFixed(2) | TrParaFormat }}</td>
                      <td style="border: 1px solid">{{ ToplamHizmet.toFixed(2) | TrParaFormat }}</td>
                      <td style="border: 1px solid">{{ ToplamYapim.toFixed(2) | TrParaFormat }}</td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </div>
            </div> </div>
          </div>
        </div>
      </div>

      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrBirimButceHarcamalari.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrBirimButceHarcamalari.Filtreleme.Content") }}
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Donem',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimKontrolTutarlari.Filtreleme.Donem'),
                  ComboDataArray: DonemCombobox,
                }"
                :Value="Filter.Donem"
                :v="$v.Filter.Donem"
                @input="Filter.Donem = $event"
              />
              
            </div>
            <b-button
              @click="FilterGet"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("StrBirimKontrolTutarlari.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
<style scoped>
.strTuru{ 
  background: rgb(180, 180, 180);
  border: 1px solid rgb(217, 215, 215);
  padding: 5px;
  border-radius: 10px;
}
.strTuru , .strTuru li{
  list-style: none;
  margin: 0px;
}
.strTuru li{
  display: flex;
  flex-flow: row;
  justify-content: space-evenly;
}
.strTuru li div{
  padding: 5px;
  background: rgb(180, 180, 180);
  width: 100%;
  height: 30px;
  border-radius: 6px;
  margin: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.strTuru li div:nth-last-child(2){
  background-color: rgb(244, 244, 244);
}
</style>